module.exports = __webpack_public_path__ + "img/MES4Indice2B_cutout.802548bb.png";